import clsx from 'clsx';
import { useLocale } from 'hooks/useLocale';
import Skeleton from 'react-loading-skeleton';
import styles from './ProgressBar.module.css';

type TProps = {
  className?: string;
};
export const ProgressBarLoader = ({ className }: TProps) => {
  const { isDE } = useLocale();
  const ukSizes: { [key: number]: string } = {
    0: '80px',
    1: '91px',
    2: '85px',
    3: '85px',
    4: '50px',
  };
  const deSizes: { [key: number]: string } = {
    0: '100px',
    1: '110px',
    2: '100px',
    3: '120px',
    4: '130px',
  };

  return (
    <div
      data-testid="progress-bar-loader"
      className={clsx(
        styles.applicationProgressBar,
        styles.skeleton,
        className,
      )}
    >
      {Array.from({ length: 5 }).map((progress, i) => (
        <div key={i} className={styles.progress}>
          <Skeleton
            baseColor="var(--color-secondary-80)"
            containerClassName={styles.icon}
            height="100%"
            circle
          />
          <Skeleton
            baseColor="var(--color-secondary-80)"
            height="13px"
            width={isDE ? deSizes[i] : ukSizes[i]}
            borderRadius="10px"
            containerClassName={styles.labelSkeleton}
          />
        </div>
      ))}
    </div>
  );
};
